import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, Package, Eye, Edit, Car } from "lucide-react";
import { motion } from "framer-motion";

const duties = [
  { id: 1, car: "KIA Sportage AWD 2023", origin: "South Korea", dutyAmount: "₨ 1,200,000", importTax: "₨ 350,000", totalDuty: "₨ 1,550,000", status: "Cleared", clearanceDate: "2026-03-15" },
  { id: 2, car: "Hyundai Tucson GLS 2024", origin: "South Korea", dutyAmount: "₨ 1,400,000", importTax: "₨ 420,000", totalDuty: "₨ 1,820,000", status: "Cleared", clearanceDate: "2026-03-20" },
  { id: 3, car: "BMW 3 Series 2023", origin: "Germany", dutyAmount: "₨ 3,200,000", importTax: "₨ 950,000", totalDuty: "₨ 4,150,000", status: "Pending", clearanceDate: "-" },
  { id: 4, car: "Toyota Prius 2024", origin: "Japan", dutyAmount: "₨ 800,000", importTax: "₨ 240,000", totalDuty: "₨ 1,040,000", status: "In Process", clearanceDate: "-" },
];

const CustomDuty = () => {
  return (
    <Layout title="Custom Duty">
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-display font-bold text-foreground">Custom Duty Records</h1>
            <p className="text-sm text-muted-foreground mt-1">Track import duties and clearance for imported cars</p>
          </div>
          <Button variant="premium" className="gap-2"><Plus className="w-4 h-4" /> Add Duty Record</Button>
        </div>

        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder="Search duty records..." className="glass-input pl-9 h-10" />
        </div>

        <div className="glass-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border/30">
                  {["Car", "Origin", "Duty Amount", "Import Tax", "Total Duty", "Clearance Date", "Status", "Actions"].map(h => (
                    <th key={h} className="text-left text-xs font-medium text-muted-foreground px-5 py-3">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {duties.map((d, i) => (
                  <motion.tr key={d.id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: i * 0.05 }} className="border-b border-border/20 hover:bg-secondary/30 transition-colors">
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                          <Package className="w-3.5 h-3.5 text-primary" />
                        </div>
                        <span className="text-sm font-medium text-foreground">{d.car}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-sm text-muted-foreground">{d.origin}</td>
                    <td className="px-5 py-3.5 text-sm text-foreground">{d.dutyAmount}</td>
                    <td className="px-5 py-3.5 text-sm text-foreground">{d.importTax}</td>
                    <td className="px-5 py-3.5 text-sm font-semibold text-primary">{d.totalDuty}</td>
                    <td className="px-5 py-3.5 text-sm text-muted-foreground">{d.clearanceDate}</td>
                    <td className="px-5 py-3.5">
                      <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                        d.status === "Cleared" ? "bg-success/10 text-success" :
                        d.status === "In Process" ? "bg-info/10 text-info" :
                        "bg-warning/10 text-warning"
                      }`}>{d.status}</span>
                    </td>
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-1">
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-foreground"><Eye className="w-3.5 h-3.5" /></Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-foreground"><Edit className="w-3.5 h-3.5" /></Button>
                      </div>
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CustomDuty;
